import type {SearchRules} from '../rules';

/**
 * Check that all rules are valid
 * @todo improve on this - just a quick check atm that there is at least one rule and all subsets have the same length
 * @param rules
 * @returns Rules are valid
 */
export const areRulesValid = (rules: SearchRules) => {
	const {
		elementTypes,
		elementSubType1s,
		elementSubType2s,
		elementValue1s,
		elementValue2s,
		elementValue3s,
	} = rules;

	const ruleLength = elementTypes.length;

	return (
		// we have at least one rule
		!!ruleLength &&
		// all items match rule length
		elementSubType1s.length === ruleLength &&
		elementSubType2s.length === ruleLength &&
		elementValue1s.length === ruleLength &&
		elementValue2s.length === ruleLength &&
		elementValue3s.length === ruleLength
	);
};

export default areRulesValid;
